import React from "react";
import { Typography, Container, IconButton, Button, Box } from "@mui/material";
import KeyOffIcon from "@mui/icons-material/KeyOff";
import { useNavigate } from "react-router-dom";
import { Route } from "../utils/Route";

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          width: 500,
          height: 200,
          backgroundColor: "white",
          textAlign: "center",
          borderRadius: "10px",
          position: "absolute",
          left: "50%",
          right: "50%",
          top: "50%",
          transform: " translate(-50%, -50%)",
          padding: 5,
        }}
      >
        <Typography variant="h6">Unauthorized</Typography>
        <IconButton>
          <KeyOffIcon sx={{ fontSize: "60px", color: "orangered" }} />
        </IconButton>
        <Box>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate(Route.DASHBOARD)}
          >
            Go to Home page
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default Unauthorized;
